import showroomService from '@/api/showroom.service'

const actions = {
  getShowroomList: context => {
    return showroomService
      .getList()
      .then(response => {
        context.commit('showroomList', response)
      })
      .catch(e => {
        reject(e)
      })
  }
}

export default actions
